import { defineEntity } from '@juvare/platform-app/App';
import { sql } from '@juvare/platform-app/Integration';
import { defineColumns } from '@juvare/platform-shared/features/storage';
import { onAttachmentChange, onAuthAttachment, onAuthGet, onAuthList, onAuthPost, onTransformColumns } from './callbacks';
export const fileVersionEntityName = 'documentLibraryFileVersion';
export const fileVersionColumns = defineColumns({
    version: {
        type: 'number-required',
    },
    checkInBy: {
        type: 'id',
    },
    checkInByName: {
        type: 'string',
    },
    contentLength: {
        type: 'number-required',
    },
    comment: {
        type: 'string',
    },
    fileId: {
        type: 'id-required',
        index: true,
    },
});
export const defineDocumentLibraryFileVersionEntity = (config, features) => defineEntity({
    version: 2,
    columns: fileVersionColumns,
    migrations: {
        'v2:2025-07-31:initial': ({ dbClient }) => {
            dbClient.update(sql `ALTER TABLE document_library_file_version_cache ADD COLUMN "version" DOUBLE PRECISION NOT NULL`);
            dbClient.update(sql `ALTER TABLE document_library_file_version_cache ADD COLUMN "check_in_by" UUID`);
            dbClient.update(sql `ALTER TABLE document_library_file_version_cache ADD COLUMN "check_in_by_name" TEXT`);
            dbClient.update(sql `ALTER TABLE document_library_file_version_cache ADD COLUMN "content_length" DOUBLE PRECISION NOT NULL`);
            dbClient.update(sql `ALTER TABLE document_library_file_version_cache ADD COLUMN "comment" TEXT`);
            dbClient.update(sql `ALTER TABLE document_library_file_version_cache ADD COLUMN "file_id" UUID NOT NULL`);
            dbClient.update(sql `CREATE INDEX IF NOT EXISTS "ix_document_library_file_version_cache_file_id" ON document_library_file_version_cache ("file_id")`);
        },
    },
    onTransformColumns: (context, params) => onTransformColumns(context, params),
    onAuthGet: onAuthGet,
    onAuthList: onAuthList,
    onAuthPost: onAuthPost,
    onAuthAttachment: onAuthAttachment(features),
    onAttachmentChange: (context, params) => onAttachmentChange(context, params),
});
